(function () {
  initializeUtilsFunctions();
  executeOnce('model-page', function () {
    function removeCarCompare() {
      const $removeButtons = [].slice.call(
        document.querySelectorAll('.remove-car-button'),
      );
      $removeButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          removeCar(btn.getAttribute('data-variation-id'), btn);
          submitForm();
        });
      });
    }

    function onClickItem() {
      document.querySelectorAll('.custom-select').forEach((el) => {
        el.querySelector('.select-items')
          .querySelectorAll('div')
          .forEach((el) => {
            el.addEventListener('click', function (e) {
              /*when an item is clicked, update the original select box,
                        and the selected item:*/
              el.parentNode.parentNode.querySelector(
                '.select-selected',
              ).innerText = el.innerText;
              el.parentNode.parentNode
                .querySelector('.select-selected')
                .setAttribute('data-value', el.getAttribute('data-value'));
            });
          });
      });
    }

    function resetSelection(i) {
      if (
        document.getElementsByClassName('list-info-accordion--title').length > 0
      ) {
        document
          .getElementsByClassName('list-info-accordion--title')[0]
          .classList.add('hidden');
        document
          .getElementsByClassName('info-variation-name')[0]
          .classList.add('hidden');
        Array.prototype.forEach.call(
          document.querySelectorAll('.item-to-clone:not(.hidden)'),
          function (node) {
            node.parentNode.removeChild(node);
          },
        );

        document
          .querySelector('.custom-select-model')
          .querySelectorAll('.custom-select')
          .forEach(function (el, index) {
            if (index > i) {
              if (
                el.querySelector('select').querySelectorAll('option').length > 0
              ) {
                el.querySelector('select')
                  .querySelectorAll('option')
                  .forEach((e) => {
                    if (e.getAttribute('value') === 'null') {
                      el.querySelector('.select-selected').setAttribute(
                        'data-value',
                        null,
                      );
                      el.querySelector('.select-selected').innerText =
                        e.innerText;
                    } else {
                      e.parentNode.removeChild(e);
                    }
                  });
              }
              if (
                el.querySelector('.select-items').querySelectorAll('div')
                  .length > 0
              ) {
                el.querySelector('.select-items')
                  .querySelectorAll('div')
                  .forEach((e) => {
                    e.parentNode.removeChild(e);
                  });
              }
              el.classList.add('disabled');
            }
          });
      }
    }

    function clickAddCompareModal(varitionName) {
      document
        .querySelectorAll('.add-model-car-compare')
        .forEach((el, index) => {
          el.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            const car = {};
            document
              .querySelector('.custom-select-model')
              .querySelectorAll('.custom-select')
              .forEach((cs) => {
                const prop = cs
                  .querySelector('select')
                  .getAttribute('data-prop');
                const propid =
                  'id_' + cs.querySelector('select').getAttribute('data-prop');
                car[propid] = cs
                  .querySelector('.select-selected')
                  .getAttribute('data-value');
                car[prop] =
                  cs.querySelector('.select-selected').childNodes[0].wholeText;
              });

            car['id_modello'] = document
              .querySelector('.model-page')
              .getAttribute('data-model-id');
            car['id_brand'] = document
              .querySelector('.model-page')
              .getAttribute('data-brand-id');
            car['modello'] = document
              .querySelector('.model-page')
              .getAttribute('data-model-name');
            car['brand'] = document
              .querySelector('.model-page')
              .getAttribute('data-brand-name');

            if (
              !!car.id_allestimento &&
              car.id_allestimento !== 'undefined' &&
              car.id_allestimento !== 'null'
            ) {
              if (
                document.querySelectorAll('.remove-car-compare-cta-modal')
                  .length
              ) {
                let error = false;
                document
                  .querySelectorAll('.remove-car-compare-cta-modal')
                  .forEach((btn) => {
                    if (
                      btn.getAttribute('id-allestimento') ===
                      car.id_allestimento
                    ) {
                      error = true;
                    }
                  });
                if (error) {
                  const notification = document.querySelector(
                    '.notification-component',
                  );
                  notification.querySelector('.title').innerText = 'Errore';
                  notification.querySelector('.description').innerText =
                    document.querySelector('#error-cart-same-car').innerHTML;
                  notification.classList.add('notification-component--error');
                  notification.classList.add('active');
                  return;
                }
              }
              if (!localStorage.getItem('firstCarCompare')) {
                localStorage.setItem('firstCarCompare', JSON.stringify(car));
                const formVariation =
                  document.querySelector('.compare-variation');
                formVariation.querySelector('#variation1').value =
                  e.currentTarget.getAttribute('data-variation-name');
                localStorage.setItem(
                  'first_variation_name',
                  e.currentTarget.getAttribute('data-variation-name'),
                );
                updateButton(car, 0);
              } else {
                const firstCar = JSON.parse(
                  localStorage.getItem('firstCarCompare'),
                );
                if (firstCar.id_allestimento !== car.id_allestimento) {
                  if (!localStorage.getItem('secondCarCompare')) {
                    localStorage.setItem(
                      'secondCarCompare',
                      JSON.stringify(car),
                    );
                    const formVariation =
                      document.querySelector('.compare-variation');
                    formVariation.querySelector('#variation2').value =
                      e.currentTarget.getAttribute('data-variation-name');
                    localStorage.setItem(
                      'second_variation_name',
                      e.currentTarget.getAttribute('data-variation-name'),
                    );
                    updateButton(car, 1);
                  } else {
                    const secondCar = JSON.parse(
                      localStorage.getItem('secondCarCompare'),
                    );
                    if (secondCar.id_allestimento !== car.id_allestimento) {
                      //acchina due presente
                      const notification = document.querySelector(
                        '.notification-component',
                      );
                      notification.querySelector('.title').innerText = 'Errore';
                      const compare_cart_error_modal_full_cart_description =
                        document.getElementById(
                          'compare-cart-error-modal-full-cart-description',
                        ).innerText;
                      notification.querySelector('.description').innerHTML =
                        compare_cart_error_modal_full_cart_description;
                      notification.classList.add(
                        'notification-component--error',
                        'active',
                      );
                      console.error('macchina due presente');
                      console.error('acchina due presente');
                    }
                    //entrambe le macchine presenti
                    const notification = document.querySelector(
                      '.notification-component',
                    );
                    notification.querySelector('.title').innerText = 'Errore';
                    const compare_cart_error_modal_full_cart_description =
                      document.getElementById(
                        'compare-cart-error-modal-full-cart-description',
                      ).innerText;
                    notification.querySelector('.description').innerHTML =
                      compare_cart_error_modal_full_cart_description;
                    notification.classList.add('notification-component--error');
                    notification.classList.add('active');
                    console.error('macchina due presente');
                    console.error('entrambe le macchine presenti');
                  }
                } else {
                  //stessa car impossibile aggiungere
                  const notification = document.querySelector(
                    '.notification-component',
                  );
                  notification.querySelector('.title').innerText = 'Errore';
                  const compare_cart_error_modal_full_cart_description =
                    document.getElementById(
                      'compare-cart-error-modal-full-cart-description',
                    ).innerText;
                  notification.querySelector('.description').innerHTML =
                    compare_cart_error_modal_full_cart_description;
                  notification.classList.add('notification-component--error');
                  notification.classList.add('active');
                  console.error('macchina due presente');
                  console.error('stessa car impossibile aggiungere');
                }
              }
              //aggiornare grafica
            } else {
              const notification = document.querySelector(
                '.notification-component',
              );
              notification.querySelector('.title').innerText = 'Errore';
              notification.querySelector('.description').innerText =
                document.querySelector('#error-client').innerHTML;
              notification.classList.add('notification-component--error');
              notification.classList.add('active');
            }
          });
        });
    }

    function setVariationInfoForLead(id, text, offer, motornet) {
      document.querySelectorAll('.form-lead').forEach((f) => {
        f.setAttribute('data-variation-id', id);
        f.setAttribute('data-motornet-id', motornet);
        f.setAttribute('data-variation-id', id);
        f.setAttribute('data-variation-name', text);
        f
          .querySelector('.mobile-sticky')
          .querySelector('.variation').innerText = text;
        f.querySelector('.form-content').querySelector('.variation').innerText =
          text;

        if (offer === 'true') {
          const span = document.createElement('span');
          span.classList.add('badge-left');
          span.innerText = 'Promo';
          f.querySelector('.form-content')
            .querySelector('.model')
            .appendChild(span);
        } else {
          const span = f
            .querySelector('.form-content')
            .querySelector('.model')
            .querySelector('.badge-left');
          if (span) {
            span.parentNode.removeChild(span);
          }
        }
      });
    }

    function addClickOnItemList(item, index) {
      const listInfos = item.querySelectorAll('.list-info');
      item.querySelector('p').addEventListener('click', function () {
        listInfos.forEach(function (info) {
          if (info.classList.contains('list-info-' + index)) {
            info.classList.toggle('active');
            item.querySelector('.icon').classList.toggle('active');
          }
        });
      });
    }

    function getInfoAccordion() {
      const listInfoAccordions = document.querySelectorAll(
        '.list-info-accordion',
      );
      if (listInfoAccordions) {
        listInfoAccordions.forEach(function (listInfoAccordion) {
          const liItems = listInfoAccordion.querySelectorAll('.item-list');
          liItems.forEach(function (item, index) {
            item.classList.add('item-' + index);
            const listInfos = item.querySelectorAll('.list-info');
            listInfos.forEach(function (info) {
              info.classList.add('list-info-' + index);
            });
            addClickOnItemList(item, index);
          });
        });
      }
    }

    function getVariationInfo(id, name) {
      document
        .querySelector('body')
        .querySelector('.loader-generic')
        .classList.add('active');

      callApi({
        uri:
          window.location.origin +
          '/api/content/car-variation/properties/' +
          id,
        method: 'GET',
      })
        .then((response) => {
          document
            .getElementsByClassName('list-info-accordion--title')[0]
            .classList.remove('hidden');
          document
            .getElementsByClassName('info-variation-name')[0]
            .classList.remove('hidden');

          Array.prototype.forEach.call(
            document.querySelectorAll('.item-to-clone:not(.hidden)'),
            function (node) {
              node.parentNode.removeChild(node);
            },
          );

          if (response) {
            for (let el in response) {
              if (
                response.hasOwnProperty(el) &&
                !Array.isArray(response[el]) &&
                Object.keys(response[el]).length > 0
              ) {
                const clone = document
                  .getElementsByClassName('item-to-clone')[0]
                  .cloneNode(true);
                clone.getElementsByClassName(
                  'item-to-clone--title',
                )[0].innerHTML = el;
                for (let row in response[el]) {
                  if (response[el][row] != '-1 ') {
                    const cloneRow = document
                      .getElementsByClassName('item-to-clone--item')[0]
                      .cloneNode(true);
                    cloneRow.getElementsByClassName(
                      'item-to-clone--item--field',
                    )[0].innerHTML = row;
                    let value;
                    if (response[el][row]['u-m']) {
                      if (response[el][row].position === 'after') {
                        value =
                          response[el][row].value +
                          ' ' +
                          response[el][row]['u-m'];
                      } else {
                        value =
                          response[el][row]['u-m'] +
                          ' ' +
                          response[el][row].value;
                      }
                    } else {
                      value = response[el][row].value;
                    }
                    cloneRow.getElementsByClassName(
                      'item-to-clone--item--value',
                    )[0].innerHTML = value;
                    cloneRow.classList.remove('hidden');
                    clone
                      .getElementsByClassName('list-info')[0]
                      .appendChild(cloneRow);
                  }
                }
                clone.classList.remove('hidden');
                document
                  .getElementsByClassName('list-info-accordion')[0]
                  .appendChild(clone);
              }
            }
            document.querySelector('.info-variation-name').innerText = name;
            document
              .querySelector('body')
              .querySelector('.loader-generic')
              .classList.remove('active');
            getVariationOptionals(id);
            updateAnalyticsData(name);
          }
        })
        .catch((e) => {
          console.error(e.message);
        });
    }

    function getVariationOptionals(id) {
      callApi({
        uri: window.location.origin + '/api/getoptional/optional/' + id,
        method: 'GET',
      })
        .then((response) => {
          {
            let optionals = [];
            for (let el in response['optional']) {
              if (
                response['optional'].hasOwnProperty(el) &&
                response['optional'][el] &&
                el !== 'nid'
              ) {
                optionals[el] = response['optional'][el];
                //  optionals[el]['show'] = Object.values(response['sanguinetti']).indexOf(el) > -1 ? true : false;
                if (
                  !response['sanguinetti'] ||
                  Object.values(response['sanguinetti']).indexOf(el) > -1
                ) {
                  optionals[el]['show'] = true;
                }
              }
            }
            const clone = document
              .getElementsByClassName('item-to-clone')[0]
              .cloneNode(true);
            clone.getElementsByClassName('item-to-clone--title')[0].innerHTML =
              document.querySelector('#variation-accessories').innerText;

            for (let el in optionals) {
              if (optionals.hasOwnProperty(el) && optionals[el].show) {
                const cloneRow = document
                  .getElementsByClassName('item-to-clone--item')[0]
                  .cloneNode(true);
                if (optionals[el]['dzg_Descrizione']) {
                  cloneRow.getElementsByClassName(
                    'item-to-clone--item--field',
                  )[0].innerHTML = el;
                  if (optionals[el]['IDGruppo'] === '2') {
                    cloneRow.getElementsByClassName(
                      'item-to-clone--item--value',
                    )[0].innerHTML = 'Da ' + optionals[el]['Prezzo'] + ' €';
                  } else if (
                    optionals[el][id] === null ||
                    optionals[el][id] === ''
                  ) {
                    row.querySelector(
                      '[data-variation-id="' + id + '"',
                    ).innerHTML = '-';
                  } else {
                    cloneRow.getElementsByClassName(
                      'item-to-clone--item--value',
                    )[0].innerHTML = 'Di serie';
                  }
                  cloneRow.classList.remove('hidden');
                  clone
                    .getElementsByClassName('list-info')[0]
                    .appendChild(cloneRow);
                  clone.classList.remove('hidden');
                  document
                    .getElementsByClassName('list-info-accordion')[0]
                    .appendChild(clone);
                }
              }
            }
            // document.querySelector('body').querySelector('.loader-generic').classList.remove('active');
          }
          getInfoAccordion();
        })
        .catch((e) => {
          console.error(e.message);
          getInfoAccordion();
        });
    }

    function getVariations(idModel, idFuel, idDisplacement, idVersion) {
      document
        .querySelector('.custom-select-model')
        .querySelector('.loader')
        .classList.add('active');

      const uri =
        '/api/filter/' +
        idModel +
        '?filter=variation_name&power_supply=' +
        idFuel +
        '&displacement_acronym=' +
        idDisplacement +
        '&preparation=' +
        idVersion;

      callApi({ uri: window.location.origin + sanitizeUri(uri), method: 'GET' })
        .then((response) => {
          const selectElements = document
            .querySelector('.custom-select-model')
            .querySelector('.custom-select-variation');
          if (selectElements) {
            response.forEach(function (model) {
              let option = document.createElement('option');
              option.setAttribute('value', model.id);
              option.innerText = model.name;
              let div = document.createElement('div');
              div.setAttribute('data-value', model.id);
              div.setAttribute('data-variation-name', model.variation_name);
              div.setAttribute('data-motornet-id', model.motornet);
              div.setAttribute('data-offer', model.onOffer);
              div.innerText = model.name;
              let divPromoEconomic = document.createElement('div');
              divPromoEconomic.classList.add('promo-economic');
              if (model.onOffer) {
                let offerSpan = document.createElement('span');
                offerSpan.classList.add('promo-label');
                offerSpan.innerHTML =
                  document.querySelector('#has-promo-badge').innerText;
                divPromoEconomic.appendChild(offerSpan);
              } else if (model.mostEconomic) {
                let mostEconomicSpan = document.createElement('span');
                mostEconomicSpan.classList.add('mostEconomic-label');
                mostEconomicSpan.innerHTML = document.querySelector(
                  '#most-economic-badge',
                ).innerText;
                divPromoEconomic.appendChild(mostEconomicSpan);
              }
              div.appendChild(divPromoEconomic);
              selectElements.querySelector('select').appendChild(option);
              selectElements.querySelector('.select-items').appendChild(div);
            });
            selectElements
              .querySelectorAll('.select-items')
              .forEach(function (el) {
                if (el.querySelector('div')) {
                  el.querySelectorAll('div').forEach(function (el) {
                    el.addEventListener('click', function (e) {
                      resetSelection(3);
                      document
                        .querySelector('.add-model-car-compare')
                        .classList.remove('disabled');
                      // addToCompareCard();
                      const cta = document.querySelector(
                        '.add-model-car-compare',
                      );
                      cta.setAttribute(
                        'data-variation-name',
                        e.currentTarget.getAttribute('data-variation-name'),
                      );
                      getVariationInfo(
                        e.currentTarget.getAttribute('data-value'),
                        e.currentTarget.childNodes[0].wholeText,
                      );
                      setVariationInfoForLead(
                        e.currentTarget.getAttribute('data-value'),
                        e.currentTarget.childNodes[0].wholeText,
                        e.currentTarget.getAttribute('data-offer'),
                        e.currentTarget.getAttribute('data-motornet-id'),
                      );
                      clickAddCompareModal(
                        e.currentTarget.getAttribute('data-variation-name'),
                      );
                    });
                  });
                }
              });
            selectElements.classList.remove('disabled');
            onClickItem();
          }
          document
            .querySelector('.custom-select-model')
            .querySelector('.loader')
            .classList.remove('active');
        })
        .catch((e) => {
          console.error(e.message);
        });
    }

    function getVersions(idModel, idFuel, idDisplacement) {
      document
        .querySelector('.custom-select-model')
        .querySelector('.loader')
        .classList.add('active');
      const uri =
        '/api/filter/' +
        idModel +
        '?filter=preparation&power_supply=' +
        idFuel +
        '&displacement_acronym=' +
        idDisplacement;

      callApi({ uri: window.location.origin + sanitizeUri(uri), method: 'GET' })
        .then((response) => {
          const selectElements = document
            .querySelector('.custom-select-model')
            .querySelector('.custom-select-version');
          if (selectElements) {
            response.forEach(function (model) {
              let option = document.createElement('option');
              option.setAttribute('value', model.id);

              let div = document.createElement('div');
              div.setAttribute('data-value', model.id);
              if (model.name == '-1') {
                //TODO Change "base" with Editorial Label
                div.innerText = 'Base';
              } else {
                div.innerText = model.name;
              }
              selectElements.querySelector('select').appendChild(option);
              selectElements.querySelector('.select-items').appendChild(div);
            });
            selectElements
              .querySelectorAll('.select-items')
              .forEach(function (el) {
                if (el.querySelector('div')) {
                  el.querySelectorAll('div').forEach(function (el) {
                    el.addEventListener('click', function () {
                      resetSelection(2);
                      getVariations(
                        idModel,
                        idFuel,
                        idDisplacement,
                        el.getAttribute('data-value'),
                      );
                    });
                  });
                }
              });
            selectElements.classList.remove('disabled');

            onClickItem();
          }
          document
            .querySelector('.custom-select-model')
            .querySelector('.loader')
            .classList.remove('active');
        })
        .catch((e) => {
          console.error(e.message);
        });
    }

    function getDisplacement(idModel, idFuel) {
      document
        .querySelector('.custom-select-model')
        .querySelector('.loader')
        .classList.add('active');
      const uri =
        '/api/filter/' +
        idModel +
        '?filter=displacement&power_supply=' +
        idFuel;

      callApi({ uri: window.location.origin + sanitizeUri(uri), method: 'GET' })
        .then((response) => {
          const selectElements = document
            .querySelector('.custom-select-model')
            .querySelector('.custom-select-displacement');
          if (selectElements) {
            response.forEach(function (model) {
              let option = document.createElement('option');
              option.setAttribute('value', model.id);
              option.innerText = model.name;
              let div = document.createElement('div');
              div.setAttribute('data-value', model.id);
              if (model.name == '-1') {
                //TODO Change "base" with Editorial Label
                div.innerText = '-';
              } else {
                div.innerText = model.name;
              }
              selectElements.querySelector('select').appendChild(option);
              selectElements.querySelector('.select-items').appendChild(div);
            });
            selectElements
              .querySelectorAll('.select-items')
              .forEach(function (el) {
                if (el.querySelector('div')) {
                  el.querySelectorAll('div').forEach(function (el) {
                    el.addEventListener('click', function () {
                      // resetSelection(2);
                      resetSelection(1);
                      document
                        .querySelector('.add-model-car-compare')
                        .classList.add('disabled');

                      getVersions(
                        idModel,
                        idFuel,
                        el.getAttribute('data-value'),
                      );
                    });
                  });
                }
              });
            selectElements.classList.remove('disabled');

            onClickItem();
          }
          document
            .querySelector('.custom-select-model')
            .querySelector('.loader')
            .classList.remove('active');
        })
        .catch((e) => {
          console.error(e.message);
        });
    }

    function getFuels(idModel) {
      document
        .querySelector('.custom-select-model')
        .querySelector('.loader')
        .classList.add('active');
      const uri = '/api/content/variation/' + idModel;

      callApi({ uri: window.location.origin + sanitizeUri(uri), method: 'GET' })
        .then((response) => {
          const selectElements = document
            .querySelector('.custom-select-model')
            .querySelector('.custom-select-fuel');
          if (selectElements) {
            response.forEach(function (model) {
              let option = document.createElement('option');
              option.setAttribute('value', model.id);
              option.innerText = model.name;
              let div = document.createElement('div');
              div.setAttribute('data-value', model.id);
              div.innerText = model.name;
              selectElements.querySelector('select').appendChild(option);
              selectElements.querySelector('.select-items').appendChild(div);
            });
            selectElements
              .querySelectorAll('.select-items')
              .forEach(function (el) {
                if (el.querySelector('div')) {
                  el.querySelectorAll('div').forEach(function (el) {
                    el.addEventListener('click', function () {
                      resetSelection(0);
                      // getVariations(idModel, el.getAttribute('data-value'));
                      document
                        .querySelector('.add-model-car-compare')
                        .classList.remove('disabled');

                      getDisplacement(idModel, el.getAttribute('data-value'));
                    });
                  });
                }
              });
            selectElements.classList.remove('disabled');

            onClickItem();
          }
          document
            .querySelector('.custom-select-model')
            .querySelector('.loader')
            .classList.remove('active');
        })
        .catch((e) => {
          console.error(e.message);
        });
    }

    function getModelId() {
      if (document.querySelector('.add-model-car-compare')) {
        document
          .querySelector('.add-model-car-compare')
          .classList.add('disabled');
        const modelId = document
          .querySelector('.model-page')
          .getAttribute('data-model-id');
        if (modelId) {
          getFuels(modelId);
        }
      }
    }

    function updateAnalyticsData(variationName) {
      analyticsModel.variation = variationName;
    }

    getModelId();
    onClickItem();
    resetSelection(0);
    removeCarCompare();
  });
})();
